/**
 * @flow
 * @relayHash 0c9f8213cd78f8a1abba1e4003687a79
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type DashboardContainer_app$ref = any;
type DashboardContainer_user$ref = any;
export type DashboardViewQueryVariables = {|
  userId: string
|};
export type DashboardViewQueryResponse = {|
  +app: ?{|
    +$fragmentRefs: DashboardContainer_app$ref
  |},
  +user: ?{|
    +$fragmentRefs: DashboardContainer_user$ref
  |},
|};
export type DashboardViewQuery = {|
  variables: DashboardViewQueryVariables,
  response: DashboardViewQueryResponse,
|};
*/


/*
query DashboardViewQuery(
  $userId: String!
) {
  app {
    ...DashboardContainer_app
    id
  }
  user(userId: $userId) {
    ...DashboardContainer_user
    id
  }
}

fragment DashboardContainer_app on App {
  isGlobalCampaignLive
  ...MoneyRaisedContainer_app
  ...UserMenuContainer_app
}

fragment DashboardContainer_user on User {
  id
  joined
  ...WidgetsContainer_user
  ...UserBackgroundImageContainer_user
  ...UserMenuContainer_user
  ...LogTabContainer_user
  ...LogRevenueContainer_user
  ...LogConsentDataContainer_user
  ...LogAccountCreationContainer_user
  ...NewUserTourContainer_user
  ...AssignExperimentGroupsContainer_user
}

fragment WidgetsContainer_user on User {
  id
  activeWidget
  ...WidgetContainer_user
  widgets(first: 20, enabled: true) {
    edges {
      node {
        id
        type
        ...WidgetContainer_widget
        ...WidgetIconContainer_widget
      }
    }
  }
}

fragment UserBackgroundImageContainer_user on User {
  id
  backgroundOption
  customImage
  backgroundColor
  backgroundImage {
    imageURL
    timestamp
    id
  }
}

fragment UserMenuContainer_user on User {
  id
  vcCurrent
  level
  heartsUntilNextLevel
  vcDonatedAllTime
  numUsersRecruited
  tabsToday
}

fragment LogTabContainer_user on User {
  id
}

fragment LogRevenueContainer_user on User {
  id
}

fragment LogConsentDataContainer_user on User {
  id
}

fragment LogAccountCreationContainer_user on User {
  tabs
}

fragment NewUserTourContainer_user on User {
  ...InviteFriendContainer_user
}

fragment AssignExperimentGroupsContainer_user on User {
  id
  joined
}

fragment InviteFriendContainer_user on User {
  username
}

fragment WidgetContainer_user on User {
  ...BookmarksWidgetContainer_user
  ...SearchWidgetContainer_user
  ...ClockWidgetContainer_user
  ...NotesWidgetContainer_user
  ...TodosWidgetContainer_user
}

fragment WidgetContainer_widget on Widget {
  type
  ...BookmarksWidgetContainer_widget
  ...SearchWidgetContainer_widget
  ...ClockWidgetContainer_widget
  ...NotesWidgetContainer_widget
  ...TodosWidgetContainer_widget
}

fragment WidgetIconContainer_widget on Widget {
  id
  type
  visible
}

fragment BookmarksWidgetContainer_widget on Widget {
  id
  name
  enabled
  visible
  data
  type
}

fragment SearchWidgetContainer_widget on Widget {
  id
  name
  enabled
  data
  config
  settings
  type
}

fragment ClockWidgetContainer_widget on Widget {
  id
  name
  enabled
  config
  settings
  type
}

fragment NotesWidgetContainer_widget on Widget {
  id
  name
  enabled
  visible
  data
  type
}

fragment TodosWidgetContainer_widget on Widget {
  id
  name
  enabled
  visible
  data
  type
}

fragment BookmarksWidgetContainer_user on User {
  id
}

fragment SearchWidgetContainer_user on User {
  id
}

fragment ClockWidgetContainer_user on User {
  id
}

fragment NotesWidgetContainer_user on User {
  id
}

fragment TodosWidgetContainer_user on User {
  id
}

fragment MoneyRaisedContainer_app on App {
  moneyRaised
  dollarsPerDayRate
}

fragment UserMenuContainer_app on App {
  referralVcReward
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId",
    "type": "String!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "DashboardViewQuery",
  "id": null,
  "text": "query DashboardViewQuery(\n  $userId: String!\n) {\n  app {\n    ...DashboardContainer_app\n    id\n  }\n  user(userId: $userId) {\n    ...DashboardContainer_user\n    id\n  }\n}\n\nfragment DashboardContainer_app on App {\n  isGlobalCampaignLive\n  ...MoneyRaisedContainer_app\n  ...UserMenuContainer_app\n}\n\nfragment DashboardContainer_user on User {\n  id\n  joined\n  ...WidgetsContainer_user\n  ...UserBackgroundImageContainer_user\n  ...UserMenuContainer_user\n  ...LogTabContainer_user\n  ...LogRevenueContainer_user\n  ...LogConsentDataContainer_user\n  ...LogAccountCreationContainer_user\n  ...NewUserTourContainer_user\n  ...AssignExperimentGroupsContainer_user\n}\n\nfragment WidgetsContainer_user on User {\n  id\n  activeWidget\n  ...WidgetContainer_user\n  widgets(first: 20, enabled: true) {\n    edges {\n      node {\n        id\n        type\n        ...WidgetContainer_widget\n        ...WidgetIconContainer_widget\n      }\n    }\n  }\n}\n\nfragment UserBackgroundImageContainer_user on User {\n  id\n  backgroundOption\n  customImage\n  backgroundColor\n  backgroundImage {\n    imageURL\n    timestamp\n    id\n  }\n}\n\nfragment UserMenuContainer_user on User {\n  id\n  vcCurrent\n  level\n  heartsUntilNextLevel\n  vcDonatedAllTime\n  numUsersRecruited\n  tabsToday\n}\n\nfragment LogTabContainer_user on User {\n  id\n}\n\nfragment LogRevenueContainer_user on User {\n  id\n}\n\nfragment LogConsentDataContainer_user on User {\n  id\n}\n\nfragment LogAccountCreationContainer_user on User {\n  tabs\n}\n\nfragment NewUserTourContainer_user on User {\n  ...InviteFriendContainer_user\n}\n\nfragment AssignExperimentGroupsContainer_user on User {\n  id\n  joined\n}\n\nfragment InviteFriendContainer_user on User {\n  username\n}\n\nfragment WidgetContainer_user on User {\n  ...BookmarksWidgetContainer_user\n  ...SearchWidgetContainer_user\n  ...ClockWidgetContainer_user\n  ...NotesWidgetContainer_user\n  ...TodosWidgetContainer_user\n}\n\nfragment WidgetContainer_widget on Widget {\n  type\n  ...BookmarksWidgetContainer_widget\n  ...SearchWidgetContainer_widget\n  ...ClockWidgetContainer_widget\n  ...NotesWidgetContainer_widget\n  ...TodosWidgetContainer_widget\n}\n\nfragment WidgetIconContainer_widget on Widget {\n  id\n  type\n  visible\n}\n\nfragment BookmarksWidgetContainer_widget on Widget {\n  id\n  name\n  enabled\n  visible\n  data\n  type\n}\n\nfragment SearchWidgetContainer_widget on Widget {\n  id\n  name\n  enabled\n  data\n  config\n  settings\n  type\n}\n\nfragment ClockWidgetContainer_widget on Widget {\n  id\n  name\n  enabled\n  config\n  settings\n  type\n}\n\nfragment NotesWidgetContainer_widget on Widget {\n  id\n  name\n  enabled\n  visible\n  data\n  type\n}\n\nfragment TodosWidgetContainer_widget on Widget {\n  id\n  name\n  enabled\n  visible\n  data\n  type\n}\n\nfragment BookmarksWidgetContainer_user on User {\n  id\n}\n\nfragment SearchWidgetContainer_user on User {\n  id\n}\n\nfragment ClockWidgetContainer_user on User {\n  id\n}\n\nfragment NotesWidgetContainer_user on User {\n  id\n}\n\nfragment TodosWidgetContainer_user on User {\n  id\n}\n\nfragment MoneyRaisedContainer_app on App {\n  moneyRaised\n  dollarsPerDayRate\n}\n\nfragment UserMenuContainer_app on App {\n  referralVcReward\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "DashboardViewQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "app",
        "storageKey": null,
        "args": null,
        "concreteType": "App",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "DashboardContainer_app",
            "args": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": v1,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "DashboardContainer_user",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "DashboardViewQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "app",
        "storageKey": null,
        "args": null,
        "concreteType": "App",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "isGlobalCampaignLive",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "moneyRaised",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "dollarsPerDayRate",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "referralVcReward",
            "args": null,
            "storageKey": null
          },
          v2
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": v1,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "vcCurrent",
            "args": null,
            "storageKey": null
          },
          v2,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "activeWidget",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "widgets",
            "storageKey": "widgets(enabled:true,first:20)",
            "args": [
              {
                "kind": "Literal",
                "name": "enabled",
                "value": true,
                "type": "Boolean"
              },
              {
                "kind": "Literal",
                "name": "first",
                "value": 20,
                "type": "Int"
              }
            ],
            "concreteType": "WidgetConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "WidgetEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Widget",
                    "plural": false,
                    "selections": [
                      v2,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "type",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "name",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "enabled",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "visible",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "data",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "config",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "settings",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "backgroundOption",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "customImage",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "backgroundColor",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "backgroundImage",
            "storageKey": null,
            "args": null,
            "concreteType": "BackgroundImage",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "imageURL",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "timestamp",
                "args": null,
                "storageKey": null
              },
              v2
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "joined",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "level",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "heartsUntilNextLevel",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "vcDonatedAllTime",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "numUsersRecruited",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "tabsToday",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "tabs",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "username",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '6d65813bcddb9b2c684e114c891ac83f';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Dashboard/__generated__/DashboardViewQuery.graphql.js